import { useSearchParams } from 'react-router';

import { LoginType } from '@/types';

import { OTPLogin, PasswordLogin } from '@/features/logins';

const LoginPage = () => {
  const [searchParams] = useSearchParams();
  const loginType = (searchParams.get('type') as LoginType) || 'otp';

  return loginType === 'password' ? <PasswordLogin /> : <OTPLogin />;
};

export default LoginPage;
